import { ErrorOutlineRounded } from '@mui/icons-material'
import { InformationCard } from 'feature/informationCard'
import { MainLayout } from 'layouts'

export function Error505() {
  return (
    <MainLayout>
      <div className='container'>
        <InformationCard
          title='ошибка 505'
          subtitle='Ошибка сервера'
          Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
          link='/'
          linkText='На главную'
        />
      </div>
    </MainLayout>
  )
}
